import React from 'react';
import { BarChart2, Brain, TrendingUp, Target, CreditCard, MessageCircle } from 'lucide-react';
const features = [{
  icon: BarChart2,
  title: 'Smart Spending Tracker',
  description: 'Automatically categorize and track every transaction across all your accounts in real-time.',
  color: 'bg-primary-500',
  lightBg: 'bg-primary-50 dark:bg-primary-900/20'
}, {
  icon: Brain,
  title: 'AI Budget Coach',
  description: 'Get personalized budget recommendations based on your spending patterns and financial goals.',
  color: 'bg-accent-500',
  lightBg: 'bg-accent-50 dark:bg-accent-900/20'
}, {
  icon: TrendingUp,
  title: 'Investment Insights',
  description: 'Analyze your portfolio performance, asset allocation, and get AI-powered investment recommendations.',
  color: 'bg-purple-500',
  lightBg: 'bg-purple-50 dark:bg-purple-900/20'
}, {
  icon: Target,
  title: 'Goal Planner',
  description: 'Set financial goals with visual progress tracking and smart contribution suggestions.',
  color: 'bg-amber-500',
  lightBg: 'bg-amber-50 dark:bg-amber-900/20'
}, {
  icon: CreditCard,
  title: 'Credit Monitor',
  description: 'Track your credit score history and get actionable tips to improve it over time.',
  color: 'bg-red-500',
  lightBg: 'bg-red-50 dark:bg-red-900/20'
}, {
  icon: MessageCircle,
  title: 'Instant AI Answers',
  description: 'Ask anything about your money and get instant, personalized answers powered by AI.',
  color: 'bg-cyan-500',
  lightBg: 'bg-cyan-50 dark:bg-cyan-900/20'
}];
export function FeaturesSection() {
  return <section className="py-20 bg-white dark:bg-dark-surface" data-id="element-796">
      <div className="max-w-7xl mx-auto px-4 sm:px-6" data-id="element-797">
        <div className="text-center mb-14" data-id="element-798">
          <p className="text-sm font-semibold text-primary-500 uppercase tracking-widest mb-3" data-id="element-799">
            Features
          </p>
          <h2 className="text-3xl sm:text-4xl font-black text-gray-900 dark:text-white mb-4" data-id="element-800">
            Everything you need to
            <br data-id="element-801" />
            master your finances
          </h2>
          <p className="text-lg text-gray-500 dark:text-gray-400 max-w-2xl mx-auto" data-id="element-802">
            One platform to track, analyze, and optimize every aspect of your
            financial life.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-803">
          {features.map((feature, i) => {
          const Icon = feature.icon;
          return <div key={i} className="group p-6 rounded-2xl border border-gray-100 dark:border-dark-border hover:border-primary-200 dark:hover:border-primary-800 hover:shadow-lg transition-all duration-300 cursor-pointer bg-white dark:bg-dark-card" data-id="element-804">
                <div className={`w-12 h-12 rounded-xl ${feature.lightBg} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform`} data-id="element-805">
                  <Icon size={22} className={feature.color.replace('bg-', 'text-')} data-id="element-806" />
                </div>
                <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2" data-id="element-807">
                  {feature.title}
                </h3>
                <p className="text-sm text-gray-500 dark:text-gray-400 leading-relaxed" data-id="element-808">
                  {feature.description}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}